import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { AllowOnlyDigitsDirective } from 'src/app/common/directive/allow-only-digits.directive';
import { ExternalEntitiesType, ExternalEntitiesTypeLabels } from 'src/app/common/enums/external-entities-type';
import { MaterialModule } from 'src/app/material.module';
import { ExternalEntitiesService } from './external-entities.service';
import { ToastrService } from 'ngx-toastr';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';

@Component({
  selector: 'app-external-entities',
  imports: [
    TranslateModule,
    MaterialModule,
    ReactiveFormsModule,
    CommonModule,
    AllowOnlyDigitsDirective,
    TablerIconsModule
  ],
  templateUrl: './external-entities.component.html',
  styleUrl: './external-entities.component.scss'
})
export class ExternalEntitiesComponent implements OnInit {
  externalEntitiesForm: FormGroup;
  externalEntityList = Object.values(ExternalEntitiesType).filter((x) => typeof x === 'number') as ExternalEntitiesType[];
  externalEntityLabels = ExternalEntitiesTypeLabels;

  constructor(
    private _formbuilder: FormBuilder,
    private dialogRef: MatDialogRef<ExternalEntitiesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { entityType: ExternalEntitiesType; title: string; prefillName?: string; },
    private _externalService: ExternalEntitiesService,
    private toastr: ToastrService,
    private translationUtils: TranslationUtils,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.externalEntitiesForm = this._formbuilder.group({
      name: [this.data.prefillName || '', [Validators.required, Validators.maxLength(50)]],
      phone: ['', [Validators.maxLength(10)]],
      address: ['', [Validators.maxLength(500)]],
      externalEntityType: [this.data.entityType, [Validators.maxLength(500)]]
    })
  }

  OnCloseDialog() {
    this.dialogRef.close();
  }

  onSaveExternalEntities() {
    if (this.externalEntitiesForm.invalid) {
      return;
    }

    const payload = this.externalEntitiesForm.value;

    this._externalService.createExternalEntities(payload).subscribe({
      next: (response) => {
        if (response.isSuccess) {
          const entityTypeLabel = this.externalEntityTypeValue === ExternalEntitiesType.FamilyDoctor 
            ? 'LABEL.FAMILY_DR' 
            : 'LABEL.ANESTHETIST';
          const message = this.translationUtils.getTranslatedMessage('COMMON.CREATE', this.translate.instant(entityTypeLabel));
          this.toastr.success(message);
          this.dialogRef.close(response.result);
        }
      },
      error: (err) => this.handleError(err)
    });
  }
  handleError(err: any): void {
    throw new Error('Method not implemented.');
  }

  get externalEntityTypeValue(): ExternalEntitiesType {
    return this.externalEntitiesForm.get('externalEntityType')?.value as ExternalEntitiesType;
  }

}
